import { RumEvent, RumEventDomainContext } from "@datadog/browser-rum";
import { shouldDiscardEvent } from "./eventFilters";
import { processEvent } from "./eventProcessors";

type BeforeSendFunc = (event: RumEvent, context: RumEventDomainContext) => boolean;

/**
 * Executes the client's beforeSend function followed by internal
 * event processing if the event was not discarded.
 * @param clientBeforeSend beforeSend function provided by client during initialization
 * @returns The final beforeSend function used to initialize Datadog RUM
 */
export function composeBeforeSend(clientBeforeSend?: BeforeSendFunc) {
  const composedBeforeSend: BeforeSendFunc = (event, context) => {
    try {
      const isBeforeSendFunction = typeof clientBeforeSend === "function";
      const isEventDiscardedByClient = isBeforeSendFunction && !clientBeforeSend(event, context);
      const isEventDiscarded = isEventDiscardedByClient || shouldDiscardEvent(event);
      if (isEventDiscarded) {
        return false;
      }
      processEvent(event);
      return true;
    } catch {
      return false;
    }
  };
  return composedBeforeSend;
}
